import NSIdentity from "./NSIdentity";
import Utility from "./Utility";
export default class Namespace {
    /**
     * create new Namespace instance.
     * You can include dots in the name
     * @param  {string[]}  ...name [description]
     * @return {Namespace}         [description]
     */
    static define(...name) {
        return Namespace.defineByArray(name);
    }
    static defineByArray(name) {
        return new Namespace(Utility.flat(name.map(n => n.split("."))));
    }
    get hierarchy() {
        return this._ns;
    }
    get qualifiedName() {
        return this._ns.join(".");
    }
    extend(extension) {
        return new Namespace(this._ns.concat([extension]));
    }
    for(name) {
        return NSIdentity.fromFQN(this, name);
    }
    toString() {
        return this.qualifiedName;
    }
    constructor(names) {
        this._ns = names;
    }
}



// WEBPACK FOOTER //
// ./src/Base/Namespace.ts